/* @flow */
// typecheck: ignore file
import React from 'react';
import { Container } from 'flux/utils';
import CurrentUser from 'auth/CurrentUser';
import PromptStore from 'stores/PromptStore';
import { allowRideToStart } from 'reducers/joyrides';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import type { RideName } from 'reducers/joyrides';
import { AdminSignupRideInformation } from 'constants/rides';
import PromptActions from 'actions/PromptActions';

const ADMIN_RIDE = 'admin-onboarding-ride';

type State = {
  startAdminRide: boolean,
};

type Props = {
  allowRideToStart: (name: RideName, onStart: Function) => any,
};

/* Joyride control tower.
 * Just like airport tower control is there to allow or deny
 * planes from landing or taking off, this allow or deny tours
 * to be started.
 */
class JoyridesControlTower extends React.Component {
  props: Props;
  state: State = {
    startAdminRide: false,
  }

  static getStores() {
    return [PromptStore, CurrentUser];
  }

  static calculateState(): State {
    const startAdminRide = (
      CurrentUser.getUser().hasFeature('web_admin_console') &&
      CurrentUser.getUser().getUserSelectedRole() === 'admin' &&
      CurrentUser.getUser().getCreatedAt() >= Date.now() - 60 * 60 * 1000 && // less than 1 hour old.
      !PromptStore.hasDismissed(ADMIN_RIDE)
    );

    return {
      startAdminRide,
    };
  }

  componentDidMount() {
    if (this.state.startAdminRide) {
      this.props.allowRideToStart(AdminSignupRideInformation.name, () => {
        PromptActions.recordDismissal(ADMIN_RIDE);
      });
    }
  }

  render() {
    return null;
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({ allowRideToStart }, dispatch);
}

export { JoyridesControlTower };

export default connect(undefined, mapDispatchToProps)(
  Container.create(JoyridesControlTower, { withProps: true })
);



// WEBPACK FOOTER //
// ./src/app/components/JoyridesControlTower.jsx